exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".seller[data-v-2d8889d8]{height:100%;text-align:left}.common-voucher[data-v-2d8889d8]{margin:.5rem auto}", ""]);

// exports
